import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import Logo from "../../../assets/Images/logo.png";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllItemDetailsRegisterReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearItemDetailsRegisterReportList } from "../reportsSlice";
import { formatIndianNumberForQty } from "../../../_helper/helper";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";

const ItemDetailsRegisterReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("itemdetailsregisterreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  console.log("initialValues", initialValues);
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .salesmanwisereport-print-break{
          page-break-before: always;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const ItemDetailsRegisterReportList = useAppSelector(
    (state) => state.reports.ItemDetailsRegisterReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      from_date: state?.from_date,
      to_date: state?.to_date,
      item_id: state?.item_id ? state?.item_id : null,
      grn_no: state?.grn_no ? `${state?.grn_no}` : null,
    };
    dispatch(getAllItemDetailsRegisterReport(payload));
    setPrintStyles();

    setTimeout(() => {
      window.print();
    }, 2000);
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("itemdetailsregisterreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearItemDetailsRegisterReportList());
    };
  }, []);

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {ItemDetailsRegisterReportList && ItemDetailsRegisterReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="text-end">
                    <ButtonWithLoading
                      buttonStyle={{
                        margin: "5px",
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      className="table table-bordered"
                      style={{ fontSize: "10px", marginBottom: "10px" }}
                    >
                      <tr>
                        <td
                          rowSpan={3}
                          style={{
                            width: "200px",
                            border: "1px solid lightgray",
                          }}
                        >
                          <div style={{ height: "100px" }}>
                            <img
                              src={`${Logo}`}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          HARIHAR FOODS PVT LTD.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            color: "gray",
                            border: "1px solid lightgray",
                          }}
                        >
                          <h6 style={{ margin: 0 }}>
                            Item Details Register Report{" "}
                          </h6>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "1px solid lightgray",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            For Period :{" "}
                            {state.from_date &&
                              state.to_date &&
                              `( ${moment(state.from_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )} )`}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className={`table table-bordered registerreport-print`}
                      // style={{
                      //   width: "fit-content",
                      // }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          {checkInclude("date", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }}>Date</th>
                            </>
                          )}
                          <th style={{ minWidth: 100 }}>No</th>
                          {checkInclude("warehouse_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 250 }}>Warehouse Name</th>
                            </>
                          )}

                          {checkInclude("process_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 200 }}>Department Name</th>
                            </>
                          )}
                          {checkInclude("quantity", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }}>Quantity</th>
                            </>
                          )}

                          {checkInclude("loss_quantity", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }}>Loss Qty</th>
                            </>
                          )}
                        </tr>
                      </thead>

                      {/* Table Body */}

                      <tbody>
                        {ItemDetailsRegisterReportList.map(
                          (item: any, rowIndex: number) => {
                            return (
                              <>
                                <tr key={rowIndex}>
                                  {checkInclude("date", formRenderProps) && (
                                    <td>
                                      {item?.date
                                        ? moment(
                                            item?.date,
                                            "DD/MM/YYYY"
                                          ).format("DD-MMM-YYYY")
                                        : ""}
                                    </td>
                                  )}
                                  <td>
                                    <div className="text-center">
                                      {item?.No}
                                    </div>
                                  </td>

                                  {checkInclude(
                                    "warehouse_name",
                                    formRenderProps
                                  ) && <td>{item?.warehouse_name}</td>}
                                  {checkInclude(
                                    "process_name",
                                    formRenderProps
                                  ) && <td>{item?.process_name}</td>}
                                  {checkInclude(
                                    "quantity",
                                    formRenderProps
                                  ) && (
                                    <td className="text-end">
                                      {item?.quantity
                                        ? formatIndianNumberForQty(
                                            item?.quantity
                                          )
                                        : ""}
                                    </td>
                                  )}
                                  {checkInclude(
                                    "loss_quantity",
                                    formRenderProps
                                  ) && (
                                    <td className="text-end">
                                      {item?.loss_quantity
                                        ? formatIndianNumberForQty(
                                            item?.loss_quantity
                                          )
                                        : ""}
                                    </td>
                                  )}
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default ItemDetailsRegisterReport;
